var render = function render(){var _vm=this,_c=_vm._self._c;return _c('empty',{staticClass:"mt-5",attrs:{"text":`Redirecting to ${_vm.authProviderName} ...`,"loading":"","show-loading-content":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }